import logo1 from './assets/logo1.svg';
import logo2 from './assets/logo2.png';
import xIcon from '../../assets/x.svg';
export default function LogoComponents() {
    return <div className='flex lg:justify-start justify-center items-start relative z-[1]'>
        <img className='lg:w-[100px] w-[64px]' src={logo1}/>
        <img className=' mx-7 my-auto' src={xIcon} style={{ height: '20px', minHeight: '20px', width: '20px', minWidth: '20px' }} />
        <img className='lg:w-[38px] w-[24px]' src={logo2} />
    </div>
}